import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = sessionStorage.getItem("jt_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    const url = e?.config?.url || "";
    if (e?.response?.status === 401 && !url.includes("/auth/")) window.dispatchEvent(new Event("jt-unauth"));
    return Promise.reject(e);
  }
);

export const errMsg = (e, fb = "Terjadi kesalahan. Silakan coba lagi.") => {
  if (!e?.response) return "Tidak dapat terhubung ke server. Periksa koneksi internet Anda.";
  const d = e.response.data?.detail;
  if (typeof d === "string") return d;
  return fb;
};

export const rp = (n) => `${n < 0 ? "-" : ""}Rp${Math.abs(Math.round(n || 0)).toLocaleString("id-ID")}`;
export const qty = (n) => Number(n || 0).toLocaleString("id-ID", { maximumFractionDigits: 3 });
export const todayJkt = () => new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Jakarta" }).format(new Date());
export const shiftDate = (s, days) => {
  const d = new Date(`${s}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
};
export const fmtDate = (s, opts = { day: "numeric", month: "short", year: "numeric" }) =>
  s ? new Date(`${s}T00:00:00`).toLocaleDateString("id-ID", opts) : "-";
export const longDate = (s) => fmtDate(s, { weekday: "long", day: "numeric", month: "long", year: "numeric" });
export const newKey = () =>
  window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

export const KIND_LABEL = {
  income: "Pemasukan",
  cust_payment: "Terima Bayar Kasbon",
  expense: "Pengeluaran",
  sup_payment: "Bayar Kasbon Pabrik",
  sup_credit: "Kasbon Pabrik",
  cust_credit: "Kasbon Pelanggan",
  usage: "Pemakaian Bahan",
  opening_stock: "Stok Awal",
  opening_cash: "Saldo Awal",
};
